let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b5WKn")).then(() => parcelRequire('91VzV'));